import { ForeAftEnum } from "open-vessel-definition";

/**
 * Gets the id a new part must reference: the part id itself, or the single bay
 * of a (possibly paired) bay id on the posRef side.
 * @param dataSlotRefId Part id, single bay ("029") or paired bays ("023-025")
 * @param dataPosRef Side of the reference where the new part goes
 */
export function extractEffectiveRefId(
  dataSlotRefId: string,
  dataPosRef: ForeAftEnum,
) {
  const [slotRefId1, slotRefId2] = dataSlotRefId.split("-");
  const isBay = !isNaN(Number(slotRefId1));

  if (!isBay) return dataSlotRefId;

  // Single (unpaired) bays only have one id, whichever the side
  return dataPosRef === ForeAftEnum.FWD
    ? slotRefId1
    : slotRefId2 ?? slotRefId1;
}
